module.exports = __webpack_public_path__ + "img/中国物流与采购联合会.37a185b1.png";